.share {
  ul {
    .displayThemeControl-true {
      display: block;
    }
    .displayThemeControl-false {
      display: none;
    }
  }
}

.share {
  background-color: #ECF1F2;
  border-radius: 6px;
  position: relative;
}

.share:before {
  content: "";
  border-style: solid;
  border-width: 0 9px 9px 9px;
  border-color: transparent transparent #ecf0f5 transparent;
  height: 0;
  position: absolute;
  right: 14px;
  top: -9px;
  width: 0;
  -webkit-transform: rotate(360deg);
}

.share ul {
  list-style-type: none;
  margin: 0;
  padding: 15px;
}

.share li {
  padding-top: 11px;
  *zoom: 1;
}

.share li:before, .share li:after {
  display: table;
  content: "";
}

.share li:after {
  clear: both;
}

.share li:first-child {
  padding-top: 0;
}

.share .toggle {
  float: right;
  margin: 0;
}

.share .btn-edit {
  padding: 6px;
  font-size: 12px;
  background-color: #253D4F;
  color: #ADC5D6;
}

.share-label {
  float: left;
  font-size: 15px;
  padding-top: 5px;
  width: 50%;
  color: #273F50;
  cursor: pointer;
}

.btn-share {
  background-color: #5A6E7E !important;
  border-radius: 0 0 6px 6px !important;
  color: white;
}

.mrl, .mhl, .mal {
  margin-right: 20px;
}

.toggle {
  background-color: #34495e;
  border-radius: 60px;
  color: white;
  height: 29px;
  margin: 0 12px 12px 0;
  overflow: hidden;
  *zoom: 1;
  display: inline-block;
  zoom: 1;
  *display: inline;
  -webkit-transition: 0.25s;
  -moz-transition: 0.25s;
  -o-transition: 0.25s;
  transition: 0.25s;
  -webkit-backface-visibility: hidden;
}

.toggle:before, .toggle:after {
  display: table;
  content: "";
}

.toggle:after {
  clear: both;
}

.toggle.toggle-false {
  background-color: #cbd2d8;
}

.toggle.toggle-false .toggle-radio {
  background-image: url("../../../assets/images/toggle/icon-off.png");
  background-position: 0 0;
  color: white;
  left: 0;
  margin-left: 0.5px;
  margin-right: -13px;
  z-index: 1;
}

.toggle.toggle-false .toggle-radio:first-child {
  left: -120%;
}

.toggle .toggle-radio {
  background: url("../../../assets/images/toggle/icon-on.png") right top no-repeat;
  color: #1abc9c;
  display: block;
  font-weight: 700;
  height: 25px;
  left: 120%;
  margin-left: -13px;
  padding: 5px 32px 3px;
  position: relative;
  text-align: center;
  z-index: 2;
  -webkit-transition: 0.25s;
  -moz-transition: 0.25s;
  -o-transition: 0.25s;
  transition: 0.25s;
  -webkit-backface-visibility: hidden;
  /* padding-bottom: 17px; */
  /* margin-bottom: -12px; */
  font-size: 14px;
  line-height: 20px;
}

.toggle .toggle-radio:first-child {
  margin-bottom: -29px;
  left: 0;
}

.toggle input {
  display: none;
  position: absolute;
  outline: none !important;
  display: block \9
;
  opacity: 0.01;
  filter: alpha(opacity=1);
  zoom: 1;
}

.toggle.toggle-icon {
  border-radius: 6px 7px 7px 6px;
}

.toggle.toggle-icon.toggle-false {
  border-radius: 7px 6px 6px 7px;
}

.toggle.toggle-icon.toggle-false .toggle-radio {
  background-image: url("../../../assets/images/toggle/block-off.png");
  background-position: 0 0;
}

.toggle.toggle-icon .toggle-radio {
  background-image: url("../../../assets/images/toggle/block-on.png");
  background-position: 62px 0;
  border-radius: 6px;
  min-width: 27px;
  text-align: right;
}

.toggle.toggle-icon .toggle-radio:first-child {
  text-align: left;
}

.toggle-radio {
  cursor: pointer;
}


// WEBPACK FOOTER //
// webpack:///var/jenkins_home/workspace/azure-dev-vm-baristadj/src/app/components/select-dropdown/select-dropdown.scss